import React, { useEffect, useState } from "react";
import {
    Box,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Paper,
    TablePagination,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { setLoading } from "../../redux/Slice/loaderSlice";

const CustomTable1 = ({ columns, apiCallFunction,data, actions, searchForm }) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [totalRows, setTotalRows] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const dispatch = useDispatch();

    useEffect(() => {
        if (apiCallFunction) {
            fetchData();
        }
    }, [currentPage, rowsPerPage, searchTerm]);

    const fetchData = async () => {
        dispatch(setLoading(true));
        try {
            const response = await dispatch(
                apiCallFunction({ page: currentPage + 1, limit: rowsPerPage, searchTerm })
            );
            if (response.payload) {
                setTotalRows(response.payload.totalPages * rowsPerPage || 0);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            dispatch(setLoading(false));
        }
    };

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(0); // Reset to first page on search
    };

    const handlePageChange = (_, newPage) => {
        setCurrentPage(newPage);
    };

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setCurrentPage(0); // Reset to first page on rows change
    };

    return (
        <Box>


{searchForm && (
                <Box display="flex" justifyContent="flex-end" marginBottom={2}>
                    <TextField
                        placeholder="Search by Name, Phone, or Email"
                        variant="outlined"
                        onChange={handleSearch}
                        sx={{ width: "300px", marginRight: 1 }}
                    />
                </Box>
            )}
             <Paper
            sx={{
                width: "100%",
                overflow: "hidden",
                boxShadow: "none",
                border: "1px solid #cacaca",
            }}
        >
           

            <TableContainer
                sx={{
                    borderRadius: "10px",
                    overflow: "hidden",
                                   }}
            >
                <Table>
                    <TableHead>
                        <TableRow>
                            {columns.map((column, index) => (
                                <TableCell key={index}>{column.headerName}</TableCell>
                            ))}
                            {actions && <TableCell>Actions</TableCell>}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data && data.length > 0 ? (
                            data.map((row, rowIndex) => (
                                <TableRow
                                    key={rowIndex}
                                    sx={{
                                        "&:nth-of-type(odd)": { backgroundColor: "#fff" },
                                        "&:hover": { backgroundColor: "#f1f1f1" },
                                    }}
                                >
                                    {columns.map((column, colIndex) => (
                                        <TableCell key={colIndex}>
                                            {column.render
                                                ? column.render(row[column.field], row)
                                                : row[column.field]}
                                        </TableCell>
                                    ))}
                                    {actions && (
                                        <TableCell>
                                            {actions.map((action, actionIndex) => (
                                                <IconButton
                                                    key={actionIndex}
                                                    onClick={() => action.onClick(row)}
                                                >
                                                    {action.icon}
                                                </IconButton>
                                            ))}
                                        </TableCell>
                                    )}
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell align="center" colSpan={columns.length + 1}>
                                    No Result Found
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                component="div"
                rowsPerPageOptions={[10, 25, 100]}
                count={totalRows}
                rowsPerPage={rowsPerPage}
                page={currentPage}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
            />
        </Paper>
        </Box>
       
    );
};

export default CustomTable1;
